import { AttentionResolutionDto } from '@/features/dashboard/attention/types/AttentionResolutionDto.ts';
import { formatDayMonthYearTime } from '@/utils/dateFormatters.ts';
import { fullNameOf } from '@/utils/personName.ts';

/** Linia audytu pod zdaniem odłożonej sprawy: „odłożył(a) Imię Nazwisko · data · komentarz”. */
export const formatResolutionNote = (
  resolution: AttentionResolutionDto,
): string => {
  const when = formatDayMonthYearTime(resolution.resolvedAt);
  const head = resolution.resolvedBy
    ? `odłożył(a) ${fullNameOf(resolution.resolvedBy.firstName, resolution.resolvedBy.lastName)} · ${when}`
    : `odłożono ${when}`;
  return resolution.comment ? `${head} · ${resolution.comment}` : head;
};
